<loader-ellipsis [invertedColor]="invertedColor"></loader-ellipsis>
